import { render, staticRenderFns } from "./ProofOfAddress.vue?vue&type=template&id=0488fa80&"
import script from "./ProofOfAddress.vue?vue&type=script&lang=js&"
export * from "./ProofOfAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports